import { useQuery, QueryKey } from "@tanstack/react-query";

type FetchFunction<TParams, TData> = (params: TParams) => Promise<TData>;

const useFilterQuery = <TParams, TData>(
  queryKey: QueryKey,
  fetchFunction: FetchFunction<TParams, TData>,
  params: TParams,
  onSettleCount: number,
  setOnSettleCount: React.Dispatch<React.SetStateAction<number>>,
  setShouldRenderDataComponent: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const {
    data,
    isFetching = true,
    refetch,
    isLoading,
  } = useQuery<TData>(queryKey, () => fetchFunction(params), {
    enabled: false,
    onSettled: (data) => {
      setShouldRenderDataComponent(true);
      if (data && typeof data === "object" && "status" in data) {
        console.log(data.status, onSettleCount, "fetching filter again");
        if (data.status === 422 && onSettleCount < 4) {
          setOnSettleCount(onSettleCount + 1);
          refetch();
        }
      }
    },
  });

  return {
    data,
    isFetching,
    refetch,
    isLoading,
  };
};

export default useFilterQuery;
